export const CORRECTION_ACTION_BUTTON_NAME = 'Approve or Reject';

export const DOWNLOAD_SUPPORTIVE_DOCUMENT_BUTTON_NAME = 'Download supportive document';

export const APPROVAL_STATUS_OPTIONS = [
	{ value: 'APPROVED', label: 'Approve' },
	{ value: 'REJECTED', label: 'Reject' },
] as const;
